export default __webpack_public_path__ + "static/media/product_icon.0aec00f6.svg";